import { createAction } from 'modules/react-redux';

export const INIT_TUTORIAL = 'APPLICATION/INIT_TUTORIAL';
export const initTitorial = () => createAction(INIT_TUTORIAL);
